import React from "react";
import {
  TableRow,
  TableCell,
  withStyles,
  TableFooter,
  withTheme,
} from "@material-ui/core";
import Message from "./components/Message";
import DriverStatus from "./components/DriverStatus";
import NextStop from "./components/NextStop";
import ClosingSoonBadge from "../../../../../modules/Dispatch/Common/ClosingSoonBadge";
import { compose } from "recompose";

const styles = (theme) => ({
  tableRowRoot: {
    height: "25px",
    verticalAlign: "top",
  },
  tableRowLast : {
    height: "25px",
    verticalAlign: "middle",
  },
  driverDetails: {
    display: "flex",
    alignItems: "center",
    float: "right",
  },
  labelCell: {
    width: "50%",
    borderBottom: 0,
    fontSize: 12,
    paddingLeft: "12px",
    paddingTop: 7,
    lineHeight: "14px",
    wordBreak: "break-all",
  },
  dualCellLeft: {
    display: "inline-block",
  },
  dualCellRight: {
    display: "inline-block",
    paddingLeft: "10px",
  },
  dataCellPickupInfo: {
    borderBottom: 0,
    paddingTop: 7,
    fontSize: 10,
    width: "80px",
    "&$lastTableCell": {
      paddingRight: 10,
      paddingTop: 7,
    },
  },
  lastRow: {
    paddingBottom: "7px",
  },
  lastTableCell: {},
  closingSoonBadgeContainer : {
    paddingLeft : 12,
    fontWeight : 600,
    marginTop : 4,
    marginBottom : 4
  },
  pickupHistory : {
    textDecoration: 'underline',
    fontSize: 12,
    paddingLeft: 12,
    cursor : "pointer",
    color: theme.headColor
  },
});
const Footer = ({
  classes,
  theme,
  driverDetails,
  stopData,
  openDriverChat,
  closingSoonTime,
  closingSoonLimitConfig,
  glEventHub,
  pickupId,
  showPickupHistory
}) => {
  const openMessageChatBox = (event) => {
    openDriverChat?.(event, driverDetails.driverId);
  };
  return (
    <TableFooter className={classes.mapPopupFooter}>
      <TableRow className={classes.tableRowRoot}>
        <TableCell className={`${classes.nameCellPadding} ${classes.labelCell} tableCellName`}>
          {driverDetails.driverName}
        </TableCell>
        <TableCell
          align="right"
          className={`${classes.dataCellPickupInfo}  ${classes.lastTableCell} tableCellValue`}>
          <div className={classes.driverDetails}>
            {openDriverChat && <Message onClick={openMessageChatBox} />}
            {`#${driverDetails.driverNumber}`}
          </div>
        </TableCell>
      </TableRow>

      {driverDetails.nextStopDetails && (
        <TableRow className={classes.tableRowRoot}>
          <TableCell className={`${classes.nameCellPadding} ${classes.labelCell} tableCellName`}>
            <div className={classes.dualCellLeft}>Next Stop</div>
          </TableCell>

          <TableCell
            align="right"
            className={`${classes.dataCellPickupInfo}  ${classes.lastTableCell} tableCellValue`}>
            <NextStop nextStopDetails={driverDetails.nextStopDetails} />
          </TableCell>
        </TableRow>
      )}

      <TableRow className={classes.tableRowRoot}>
        <TableCell
          className={`${classes.nameCellPadding} ${classes.labelCell} ${classes.lastRow} tableCellName`}>
          <div className={classes.dualCellLeft}>Current Status</div>
        </TableCell>
        <TableCell
          align="right"
          className={`${classes.dataCellPickupInfo}  ${classes.lastTableCell} ${classes.lastRow} tableCellValue`}>
          <DriverStatus
            driverStatusDetails={driverDetails.driverStatusDetails}
            currentStop={stopData}
            theme={theme}
          />
        </TableCell>
      </TableRow>
      {showPickupHistory && pickupId && stopData.pickupIdList.length === 1 && (
        <TableRow className={classes.tableRowRoot}>
          <TableCell colSpan={2} className={`${classes.tableRowLast} popupBGColor`}>
            <span
              className={classes.pickupHistory}
              onClick={() => glEventHub.emit('showPickupDetails', pickupId, true)}>
              Pickup history
            </span>
          </TableCell>
        </TableRow>
      )}
      {closingSoonTime !== null && (
        <TableRow className={`${classes.tableRowLast} popupBGColor`}>
          <TableCell
            colSpan={2}
            className={`${classes.nameCellPadding} ${classes.labelCell} ${classes.lastRow} tableCellName`}>
            <div className={`${classes.dualCellLeft} ${classes.closingSoonBadgeContainer}`}>
              <ClosingSoonBadge
                timeToCloseInMins={closingSoonTime}
                closingSoonLimitConfig={closingSoonLimitConfig}
              />
            </div>
          </TableCell>
        </TableRow>
      )}
    </TableFooter>
  );
};

export default compose(withStyles(styles), withTheme())(Footer);
